/**
 * Created by Ivan on 24.05.2025
 */

const MouseAndCheeseTutorial = function () {
    return new TutorialScenario(MouseAndCheeseTutorial.NAME, {
        listSteps: () => [
            TileGameTutorialHelper.createPlayCardStep(MouseAndCheeseTutorial.CONFIG)
        ],

        onStart: function () {
            Game.currentGame.shownTutorials.push(MouseAndCheeseTutorial.NAME);
            Game.currentGame.hand.setCards(MouseAndCheeseTutorial.CONFIG.handValues);
        },

        isAvailable: () => TileGameTutorialHelper.isAvailable(MouseAndCheeseTutorial.NAME)
    });
};

MouseAndCheeseTutorial.NAME = "mouseAndCheese";
MouseAndCheeseTutorial.CONFIG = {
    handValues: ["8"],
    force: "MouseAndCheeseTutorialMessage",
    filter: [MouseCard, CheeseCard]
};
